import React from 'react'

function ModuleError(){
  return (<div>
    Module Error
    Something Got Fucked Up
  </div>)
}
export default ModuleError
